export const getHasReportedAppLoad = (state) => state.appLoaded.hasReported;
